import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../services/auth.service";
var NotLoggedInGuard = /** @class */ (function () {
    function NotLoggedInGuard(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    NotLoggedInGuard.prototype.canActivate = function (next, state) {
        var access_token = localStorage.getItem(this.authService.ACCESS_TOKEN_KEY);
        var refresh_token = localStorage.getItem(this.authService.REFRESH_TOKEN_KEY);
        if (!(access_token && refresh_token)) {
            return true;
        }
        this.router.navigate(['']);
    };
    NotLoggedInGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotLoggedInGuard_Factory() { return new NotLoggedInGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService)); }, token: NotLoggedInGuard, providedIn: "root" });
    return NotLoggedInGuard;
}());
export { NotLoggedInGuard };
